import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';

import { LazyLoadImageModule } from 'ng-lazyload-image';

import { FrontRoutingModule } from './routing.module';
import { FrontRootComponent } from './root.component';
import { CookieConsentComponent } from './cookie-consent.component';
import { ContentRecordsComponent } from './content-records.component';
import { SearchFacetsComponent } from './search-facets.component';
import { HomeComponent } from './home.component';
import { ContentRecordsFeaturedComponent } from './content-records-featured.component';
import { ContentSpecialsComponent } from './content-specials.component';
import { ContentWritingComponent } from './content-writing.component';
import { ContentWritingsComponent } from './content-writings.component';
import { SearchAZComponent } from './search-az.component';
import { ContentPageComponent } from './content-page.component';
import { ContentRecordComponent } from './content-record.component';
import { CartService } from './cart.service';
import { CartWidgetComponent } from './cart-widget.component';
import { CartComponent } from './cart.component';
import { PaymentPayPalExpressCheckoutComponent } from './payment-paypal-express-checkout.component';
import { PageNotFoundComponent } from './page-not-found.component';
// test
import { BrowserComponent } from './browser.component';

import { AUTO_PREBOOT } from "angular2-universal";

@NgModule({
  declarations: [ 
    FrontRootComponent, HomeComponent, CookieConsentComponent,
    ContentPageComponent, ContentRecordComponent, ContentRecordsComponent,
    ContentRecordsFeaturedComponent, ContentSpecialsComponent,
    ContentWritingComponent, ContentWritingsComponent,
    SearchFacetsComponent, SearchAZComponent,
    CartWidgetComponent, CartComponent, PaymentPayPalExpressCheckoutComponent,
    PageNotFoundComponent,
    BrowserComponent
  ],
  imports: [ 
    FrontRoutingModule, 
    SharedModule,
    LazyLoadImageModule
  ],
  providers: [ 
    CartService,
    {
      provide: AUTO_PREBOOT,
      useValue: false
    }
  ],
})
export class FrontModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/front.module.ts